import { DropDownListOption } from '@design-system/components/templates/drop-down-list/entities/drop-down-list.types';

export enum DropDownFieldType {
  FieldList = 'FieldList',
  Field = 'Field'
}

export interface DropDownFieldEvent {
  Type: DropDownFieldType;
  Option: DropDownListOption;
}
